import { combineReducers } from "redux"
import layersReducer from "./layers/slice"
import eventReducer from "./event/slice"
import controlReducer from "./control/slice"
import zoomReducer from "./zoom/slice"
import searchReducer from "./search/slice"

export const mapReducers = combineReducers({
    layers: layersReducer,
    event: eventReducer,
    control: controlReducer,
    zoom: zoomReducer,
    search: searchReducer,
})

export default mapReducers
